import React, { useEffect } from 'react';
import { Dialog, Box, Typography } from '@mui/material';
import styles from './Dtlresultspopup.module.css';
import { dtlresult } from '../../../store/slices/casinoResultsSlice';
import { useDispatch, useSelector } from 'react-redux';

const parseCard = (cardStr) => {
    if (!cardStr || typeof cardStr !== 'string') 
        return { value: '-', suit: '', isRed: false };

    const raw = cardStr.trim().toUpperCase();
    const suitMap = { HH: '♥', DD: '♦', CC: '♣', SS: '♠' };
    const redSuits = ['♥', '♦'];

    const suitCode = raw.slice(-2);
    let rank = raw.slice(0, -2) || '-';

    const suit = suitMap[suitCode] || suitCode;

    return {
        value: rank === '1' ? 'A' : rank,
        suit,
        isRed: redSuits.includes(suit)
    };
};

const CloseSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <g clipPath="url(#clip0_lucky7_close)">
            <path d="M0.586047 12.0001C0.470144 12.0001 0.356837 11.9657 0.26046 11.9014C0.164083 11.837 0.0889654 11.7455 0.0446082 11.6384C0.000250996 11.5313 -0.0113527 11.4135 0.0112649 11.2998C0.0338824 11.1861 0.0897052 11.0817 0.171672 10.9998L10.9998 0.17164C11.1097 0.0617407 11.2588 0 11.4142 0C11.5696 0 11.7186 0.0617407 11.8285 0.17164C11.9384 0.281539 12.0002 0.430594 12.0002 0.586015C12.0002 0.741436 11.9384 0.890491 11.8285 1.00039L1.00042 11.8285C0.946056 11.883 0.881462 11.9262 0.810351 11.9556C0.739239 11.9851 0.663012 12.0002 0.586047 12.0001Z" fill="white" />
            <path d="M11.4141 12.0001C11.3372 12.0002 11.2609 11.9851 11.1898 11.9556C11.1187 11.9262 11.0541 11.883 10.9998 11.8285L0.17164 1.00039C0.0617407 0.890491 0 0.741436 0 0.586015C0 0.430594 0.0617407 0.281539 0.17164 0.17164C0.281539 0.0617407 0.430594 0 0.586015 0C0.741436 0 0.890491 0.0617407 1.00039 0.17164L11.8285 10.9998C11.9105 11.0817 11.9663 11.1861 11.9889 11.2998C12.0115 11.4135 11.9999 11.5313 11.9556 11.6384C11.9112 11.7455 11.8361 11.837 11.7397 11.9014C11.6433 11.9657 11.53 12.0001 11.4141 12.0001Z" fill="white" />
        </g>
        <defs>
            <clipPath id="clip0_lucky7_close">
                <rect width="12" height="12" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const Dragon_Tiger_LionResultPopup = ({ open, onClose, resultData }) => {
    const dispatch = useDispatch();
    const reduxData = useSelector((state) => state.casinoResults.dtl);

    // ✅ resultData (dot click) → directly use karo
    // Warna Redux se latest (array ka [0] ya object)
    let apiData = resultData
        ? resultData
        : Array.isArray(reduxData)
            ? reduxData[0]
            : reduxData?.data || reduxData;

    useEffect(() => {
        // ✅ Sirf tab dispatch karo jab dot click se nahi aaya
        if (open && !resultData) {
            dispatch(dtlresult());
        }
    }, [open, resultData, dispatch]);
 

    const roundId   = apiData?.roundId  || '-';
    const matchTime    = apiData?.settledAt || apiData?.settled_at || apiData?.matchTime || '-'
    // Card Data
    const dragonCard = parseCard(apiData?.dragonCard);
    const tigerCard  = parseCard(apiData?.tigerCard);
    const lionCard   = parseCard(apiData?.lionCard);

    const winner = apiData?.winner || '-';

    // Extra Details
    const dragonColor  = apiData?.dragonColor  || apiData?.dragon_color || '-';
    const tigerColor   = apiData?.tigerColor   || '-';
    const lionColor    = apiData?.lionColor    || '-';

    const dragonParity = apiData?.dragonParity || '-';
    const tigerParity  = apiData?.tigerParity  || '-';
    const lionParity   = apiData?.lionParity   || '-';

    const dragonRank   = apiData?.dragonRank   || '-';
    const tigerRank    = apiData?.tigerRank    || '-';
    const lionRank     = apiData?.lionRank     || '-';

    return (
        <Dialog
            open={open}
            onClose={onClose}
            className={styles.betDialogOpen_container}
            PaperProps={{
                style: {
                    position: 'absolute',
                    top: 50,
                    width: '100%',
                    maxWidth: '480px',
                    borderRadius: '0px',
                    margin: 0,
                },
            }}
        >
            <Box className={styles.Dialog_header}>
                <Typography className={styles.betDialog_header_txt}>
                    Dragon Tiger Lion Results
                </Typography>
                <span onClick={onClose} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                    <CloseSVG />
                </span>
            </Box>

            <Box className={styles.Dialog_body}>
                <Box className={styles.roundId_TextField_container}>
                    <Typography sx={{ fontSize: '12px', color: '#333' }}>Round Id: <strong>{roundId}</strong></Typography>
                    <Typography sx={{ fontSize: '12px', color: '#333' }}>Match Time: <strong>{matchTime}</strong></Typography>
                </Box>

                {/* 3 Cards */}
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>

                    {/* Dragon */}
                    <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#365e3b' }}>Dragon</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Box className={styles.Cards_container}>
                            <Typography className={styles.Cards_number} sx={{ color: dragonCard.isRed ? '#e00' : '#111' }}>
                                {dragonCard.value}
                            </Typography>
                            <Typography sx={{ color: dragonCard.isRed ? '#e00' : '#111', fontSize: '18px', lineHeight: 1 }}>
                                {dragonCard.suit}
                            </Typography>
                        </Box>
                        {winner.toLowerCase() === 'dragon' && <span>🏆</span>}
                    </Box>

                    {/* Tiger */}
                    <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#365e3b' }}>Tiger</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Box className={styles.Cards_container}>
                            <Typography className={styles.Cards_number} sx={{ color: tigerCard.isRed ? '#e00' : '#111' }}>
                                {tigerCard.value}
                            </Typography>
                            <Typography sx={{ color: tigerCard.isRed ? '#e00' : '#111', fontSize: '18px', lineHeight: 1 }}>
                                {tigerCard.suit}
                            </Typography>
                        </Box>
                        {winner.toLowerCase() === 'tiger' && <span>🏆</span>}
                    </Box>

                    {/* Lion */}
                    <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#365e3b' }}>Lion</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Box className={styles.Cards_container}>
                            <Typography className={styles.Cards_number} sx={{ color: lionCard.isRed ? '#e00' : '#111' }}>
                                {lionCard.value}
                            </Typography>
                            <Typography sx={{ color: lionCard.isRed ? '#e00' : '#111', fontSize: '18px', lineHeight: 1 }}>
                                {lionCard.suit}
                            </Typography>
                        </Box>
                        {winner.toLowerCase() === 'lion' && <span>🏆</span>}
                    </Box>

                </Box>

                <Box className={styles.divider} />

                {/* Bottom Info */}
                <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <Typography sx={{ fontSize: '13px', color: '#333' }}>
                        Winner: <strong>{winner}</strong>
                    </Typography>
                    <Typography sx={{ fontSize: '12px', color: '#555' }}>
                        Red/Black : D: {dragonColor} | T: {tigerColor} | L: {lionColor}
                    </Typography>
                    <Typography sx={{ fontSize: '12px', color: '#555' }}>
                        Odd/Even : D: {dragonParity} | T: {tigerParity} | L: {lionParity}
                    </Typography>
                    <Typography sx={{ fontSize: '12px', color: '#555' }}>
                        Card : D: {dragonRank} | T: {tigerRank} | L: {lionRank}
                    </Typography>
                </Box>
            </Box>
        </Dialog>
    );
};

export default Dragon_Tiger_LionResultPopup;